<p class="type-room-select mb-0" [ngStyle]="{'color': styleSidebar?.color}" style="text-transform: capitalize;">{{item.roomType}}</p>
<p class="type-room mb-0" [ngStyle]="{'color': styleSidebar?.color}" style="text-transform: capitalize;">{{item.boardName}}</p>

<div class="d-flex flex-column detail-item" [ngStyle]="{'width': item.categoryName === 'TRANSPORTS'  ? '' : 'calc(100% - -25px)'}">
  <div *ngIf="(item.categoryName == 'HOTELS' || item.categoryName == 'PARKS')" class="hotel-date font-poppins m-0">
    <p class="mb-0 mt-2" [ngStyle]="{'color': styleSidebar?.color}"><strong class="font-verde" style="text-transform: capitalize;">In:&nbsp;&nbsp;&nbsp;&nbsp;</strong>{{ item.arrivalDate | date: 'dd/MM/yyyy' }}</p>
    <p class="mb-0 mt-0" [ngStyle]="{'color': styleSidebar?.color}"><strong class="font-verde" style="text-transform: capitalize;">Out: </strong>{{  item.departureDate | date: 'dd/MM/yyyy' }}</p>
    <p class="mb-0 mt-2" [ngStyle]="{'color': styleSidebar?.color}"><strong class="font-verde" style="text-transform: capitalize;">Check In:&nbsp;&nbsp;&nbsp;&nbsp;</strong>
      <span style="text-transform: uppercase;">{{  item?.checkTimes?.checkIn && item.checkTimes.checkIn.trim() ? item.checkTimes.checkIn : 'n/a' }}</span>
    </p>
    <p class="mb-0 mt-0" [ngStyle]="{'color': styleSidebar?.color}"><strong class="font-verde" style="text-transform: capitalize;">Check Out: </strong>
      <span style="text-transform: uppercase;">{{ item?.checkTimes?.checkOut && item.checkTimes.checkOut.trim() ? item.checkTimes.checkOut : 'n/a' }}</span>
    </p>
  </div>

  <div
      class="d-flex"
      style="color: #939295; width: max-content"
      [ngClass]="{ 'justify-content-center': item?.categoryName == 'TOURS' }"
  >
    <p
      [ngStyle]="{ color: styleSidebar?.color }"
      class="hotel-room m-0 mt-1"
      style="font-family: 'Rubik', serif;text-transform: lowercase;display: flex;align-items: center; width: 100%;">
      1 Hab
    </p>
    <ng-container *ngIf="item.status_id === 1 && (item.categoryName == 'HOTELS' || item.categoryName == 'PARKS')">
      <span class="ml-2 pl-1 dark-1 mt-1" style="display: flex; align-items: center; gap: 3px">
        <img #icon src="../../../assets/img/app/little-icons/user.svg" class="ml-2" style="width: 16px" alt="" />
        <p
          class="mb-0"
          [ngStyle]="{ color: styleSidebar?.color }"
          style="font-family: 'Rubik'; font-size: 12px; font-weight: 500; margin-top: 3.5px"
        >
          {{ item?.paxAdults }}
        </p>
      </span>
      <span class="ml-2 dark-1 mt-1" style="display: flex; align-items: center; gap: 3px">
        <img
          #icons_two
          src="../../../assets/img/app/little-icons/children-2.svg"
          class="ml-2"
          style="width: 14px"
          alt=""
        />
        <p
          class="mb-0"
          [ngStyle]="{ color: styleSidebar?.color }"
          style="font-family: 'Rubik'; font-size: 12px; font-weight: 500; margin-top: 3.5px"
        >
                                    {{ item?.paxChildren }}
                                  </p>
                                </span>
                              </ng-container>
                              <ng-container *ngIf="item.status_id !== 1 && (item.categoryName == 'HOTELS' || item.categoryName == 'PARKS')">
                                <span class="ml-2 pl-1 dark-1 mt-1" style="display: flex; align-items: center; gap: 3px">
                                  <!-- <span class="icon icon-user dark-1" style="font-size: 15px">
                                    </span>  -->
                                  <img #icon src="../../../assets/img/app/little-icons/user.svg" class="ml-2" style="width: 16px" alt="" />
                                  <!-- <i class="bi bi-person-fill mt-1" style="font-size: 17px;" aria-hidden="true"></i> -->
                                  <p
                                    class="mb-0"
                                    [ngStyle]="{ color: styleSidebar?.color }"
                                    style="font-family: 'Rubik'; font-size: 12px; font-weight: 500; margin-top: 3.5px"
                                  >
                                    {{ item?.form?.room?.qtyAdults }}
                                  </p>
                                </span>
                                <span class="ml-2 dark-1 mt-1" style="display: flex; align-items: center; gap: 3px">
                                  <!-- <span class="icon icon-child"></span> -->
                                  <img
                                    #icons_two
                                    src="../../../assets/img/app/little-icons/children-2.svg"
                                    class="ml-2"
                                    style="width: 14px"
                                    alt=""
                                  />
                                  <p
                                    class="mb-0"
                                    [ngStyle]="{ color: styleSidebar?.color }"
                                    style="font-family: 'Rubik'; font-size: 12px; font-weight: 500; margin-top: 3.5px"
                                  >
                                    {{
                                      item?.payloadUpdate?.products[0]?.others?.hotels?.roomConfiguration[0]?.children?.length
                                        ? item?.payloadUpdate?.products[0]?.others?.hotels?.roomConfiguration[0]?.children?.length
                                        : 0
                                    }}
                                  </p>
                                </span>
                              </ng-container>
  </div>

</div>
